<app-expandable-section-box
  [title]="'Authors'"
  [iconClass]="'icon-user'"
  [isExpandedByDefault]="isExpandedByDefault"
  [isExpandable]="isExpandable"
  data-testid="authorsComponentSection"
  id="authorsComponentSection"
>
  <div
    class="flex flex-col gap-y-[0.3rem] py-0 px-2 flex-1"
    data-testid="authorsComponent"
    id="authorsComponent"
    expandedContent
  >
    <app-auto-complete
      id="formSectionAuthorsAuto"
      data-testid="formSectionAuthorsAuto"
      class="flex flex-col flex-1"
      [searchList]="searchList"
      [searchBarControl]="searchedAuthor"
      [isSearching]="isSearchingAuthors"
      (handleSelectedResult)="handleAuthorSelected($event)"
    ></app-auto-complete>

    <div
      class="flex flex-col flex-1 px-0 py-2 m-0 border-t border-t-project-100"
      *ngIf="this.selectedAuthors?.value?.length"
    >
      <ng-container *ngFor="let selectedAuthor of this.selectedAuthors?.value">
        <app-authors-item
          [selectedAuthor]="selectedAuthor"
          (onRemoveAuthor)="onRemoveAuthor($event)"
          (onEditLocation)="updateSelectedAuthorLocation($event)"
          (onRefreshAuthor)="refreshAuthor($event)"
        />
      </ng-container>
    </div>
  </div>
  <div
    class="flex flex-col flex-1 p-4 space-y-2"
    *ngIf="selectedAuthors?.value.length"
    notExpandedContent
  >
    <ng-container *ngFor="let author of selectedAuthors?.value">
      <div>
        <p class="text-xs font-bold text-project-500">
          {{ author.name }}
        </p>
        <p *ngIf="author?.location" class="py-px text-xs text-project-2400">
          {{ author.location }}
        </p>
      </div>
    </ng-container>
  </div>
</app-expandable-section-box>
